import FormClient from "@/repositories/FormClient";

export default {

    postForm(url, payload,headers) {
        return FormClient.post(`${url}`, payload, headers);
    },

};